import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userDetails: null
}

const userDetailSlice = createSlice({
    name: "User Details",
    initialState: initialState,
    reducers: {
        getUserDetails: (state, actions) => {
            state.userDetails = actions.payload
        }
    }
})


export const { getUserDetails } = userDetailSlice.actions

export default userDetailSlice.reducer